import React from "react";
import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { ASSETS } from "../lib/assets";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      data-glow="footer"
      className="relative z-10 px-6 sm:px-10 lg:px-20 pt-16 pb-10 max-w-[1500px] mx-auto"
      style={{ borderTop: "1px solid rgba(244,152,0,0.08)" }}
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img
              src={ASSETS.logo}
              alt="Monoton"
              style={{ width: 36, height: 36, mixBlendMode: "screen" }}
            />
            <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-offwhite">
              monoton · eventtechnik
            </span>
          </div>
          <p className="body-mute text-sm max-w-xs leading-relaxed">
            Veranstaltungstechnik aus Nürnberg. Licht, Ton, Stage —
            leidenschaftlich, kreativ, menschlich.
          </p>
        </div>

        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-amber/70 mb-4">
            Sitemap
          </p>
          <ul className="space-y-2">
            {[
              { l: "Leistungen", id: "services" },
              { l: "Projekte", id: "projects" },
              { l: "Über uns", id: "about" },
              { l: "Kontakt", id: "contact" },
            ].map((i) => (
              <li key={i.id}>
                <button
                  onClick={() =>
                    document.getElementById(i.id)?.scrollIntoView({ behavior: "smooth" })
                  }
                  className="font-display text-sm text-offwhite/80 hover:text-amber transition-colors"
                >
                  {i.l}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-amber/70 mb-4">
            Kontakt
          </p>
          <ul className="space-y-2 text-sm body-mute">
            <li>Blütenstraße 6</li>
            <li>90480 Nürnberg</li>
            <li className="pt-2">
              <a
                href="mailto:hello@monoton.events"
                className="hover:text-amber transition-colors"
              >
                hello@monoton.events
              </a>
            </li>
            <li>
              <a
                href="mailto:rental@monoton.events"
                className="hover:text-amber transition-colors"
              >
                rental@monoton.events
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 pt-6"
           style={{ borderTop: "1px solid rgba(244,152,0,0.06)" }}>
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-mute">
          © {new Date().getFullYear()} monoton. Veranstaltungstechnik
        </p>
        <div className="flex items-center gap-4">
          <a
            href="https://www.instagram.com/monoton.events/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-mute hover:text-amber transition-colors"
            aria-label="Instagram"
          >
            <Instagram size={14} />
          </a>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-mute">
            <Link to="/impressum" className="hover:text-amber transition-colors">Impressum</Link>
            <span className="mx-3">·</span>
            <Link to="/datenschutz" className="hover:text-amber transition-colors">Datenschutz</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};
